// Loading state pra tela inteira: spinner grande centralizado + texto opcional.
// Usar quando a tela está vazia esperando dados (Movies/Series/Live carregando).

import { useTranslation } from '@app-iptv/i18n'

import styles from './LoadingScreen.module.css'
import { Spinner } from './Spinner'

interface LoadingScreenProps {
  /** Texto abaixo do spinner. Default: t('common.loading'). */
  text?: string
  /** Embedded em container existente (sem min-height: 100vh). */
  inline?: boolean
}

export function LoadingScreen({ text, inline = false }: LoadingScreenProps) {
  const { t } = useTranslation()
  const label = text ?? t('common.loading')
  return (
    <div className={`${styles.container} ${inline ? styles.inline : ''}`}>
      <Spinner size="lg" label={label} />
      {label && <div className={styles.text}>{label}</div>}
    </div>
  )
}
